import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./user/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import PublicRoute from "./components/PublicRoute";
import AdminDashboard from "./admin/AdminDashboard";
import AdminUsers from "./admin/AdminUsers";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import AdminProduct from "./admin/AdminProduct";
import AdminAddProduct from "./admin/AdminAddProduct";
import AdminEditProduct from "./admin/AdminEditProduct";
import AdminOrder from "./admin/AdminOrder";
import AdminLeaderboard from "./admin/AdminMonthlySpend.js";
import ProductInfo from "./pages/ProductInfo";
import Orders from "./user/Orders";
import ViewOrder from "./user/ViewOrder";
import AdminGallery from "./admin/AdminGallery.js";
import AdminBanners from "./admin/AdminBanners.js";
import AdminProductCategory from "./admin/AdminProductCategory.js";
import AdminWalletHistory from "./admin/AdminWalletHistory.js";
import WalletReload from "./pages/WalletReload.js";
import PublicLeaderboard from "./pages/PublicLeaderboard";
import NameCheck from "./pages/NameCheck.js";
import Games from "./pages/Games.js";
import Subscription from "./pages/Subscription.js";
import AdminSubscriptionPlans from "./admin/AdminSubscriptionPlans.js";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* pages */}
        <Route path="/" element={<Home />} />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route path="/product/:name?" element={<ProductInfo />} />
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-order/:orderId?"
          element={
            <ProtectedRoute>
              <ViewOrder />
            </ProtectedRoute>
          }
        />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/leaderboard" element={<PublicLeaderboard />} />
        <Route path="/name-check" element={<NameCheck />} />
        <Route path="/games" element={<Games />} />
        {/* ======================== USER PAGES =============================== */}
        {/* ========== EMAIL VERIFY */}
        <Route
          path="/user-dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-balance"
          element={
            <ProtectedRoute>
              <WalletReload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription"
          element={
            <ProtectedRoute>
              <Subscription />
            </ProtectedRoute>
          }
        />
        {/* ======================== USER PAGES =============================== */}
        {/* ======================== ADMIN PAGES =============================== */}

        <Route path="/admin-dashboard"        element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin-orders"           element={<AdminRoute><AdminOrder /></AdminRoute>} />
        <Route path="/admin-products"         element={<AdminRoute><AdminProduct /></AdminRoute>} />
        <Route path="/admin-add-product"      element={<AdminRoute><AdminAddProduct /></AdminRoute>} />
        <Route path="/admin-edit-product/:id?" element={<AdminRoute><AdminEditProduct /></AdminRoute>} />
        <Route path="/admin-users"            element={<AdminRoute><AdminUsers /></AdminRoute>} />
        <Route path="/admin-gallery"          element={<AdminRoute><AdminGallery /></AdminRoute>} />
        <Route path="/admin-banners"          element={<AdminRoute><AdminBanners /></AdminRoute>} />
        <Route path="/admin-product-category" element={<AdminRoute><AdminProductCategory /></AdminRoute>} />
        <Route path="/admin-wallet-history"      element={<AdminRoute><AdminWalletHistory /></AdminRoute>} />
        <Route path="/admin-leaderboard"         element={<AdminRoute><AdminLeaderboard /></AdminRoute>} />
        <Route path="/admin-subscription-plans"  element={<AdminRoute><AdminSubscriptionPlans /></AdminRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
